import React from 'react';
import { Platform, View, StyleSheet, useWindowDimensions } from 'react-native';
import LHOverlay from '../../../components/LHOverlay';
import { AdminColors } from '../constants/adminColors';
import { useTheme } from '../../../theme/useTheme';

interface AdminModalProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
}

const AdminModal: React.FC<AdminModalProps> = ({
  visible,
  title,
  onClose,
  children,
  footer,
  width = 560,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const { width: screenWidth } = useWindowDimensions();
  // On narrow screens let LHOverlay use its own responsive sizing
  const overlayWidth = screenWidth < 600 ? undefined : width;

  return (
    <LHOverlay
      visible={visible}
      title={title}
      titleStyle={{ color: isDark ? '#FFFFFF' : '#2D2D2D' }}
      onDismiss={onClose}
      width={overlayWidth}
      hideFooter
      dismissOnClickOutside={true}
      bodyPadding={0}
    >
      <View style={styles.body}>{children}</View>
      {footer && (
        <View
          style={[
            styles.footer,
            isDark && { borderTopColor: colors.border.divider },
          ]}
        >
          {footer}
        </View>
      )}
    </LHOverlay>
  );
};

const styles = StyleSheet.create({
  body: {
    padding: 20,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: AdminColors.gray25,
  },
});

export default AdminModal;
